import { useClientQuery } from "@graphql/clients/clients.g";
import { useParams } from "react-router";

export const CurrentClientName = () => {
  const { clientId } = useParams();

  const clientQuery = useClientQuery(
    {
      clientId,
    },
    {
      enabled: !!clientId,
    },
  );

  const client = clientQuery.data?.client;

  return client?.name;
};
